import { Component, EventEmitter, Output } from "@angular/core";
import * as url from "node:url";
import { FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { ApiServiceService } from "../../../../../Services/api-service.service";
import alertify from "alertifyjs";
import { firstValueFrom } from "rxjs";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-individual-landing",
  templateUrl: "./individual-landing.component.html",
  styleUrls: ["./individual-landing.component.css"],
  providers: [DatePipe],
})
export class IndividualLandingComponent {
  previewDetails: any;
  biodata: any;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private apiServer: ApiServiceService,
    private datePipe: DatePipe
  ) {}

  type: boolean = true;
  step1: boolean = true;
  step2: boolean = false;
  step3: boolean = false;
  step4: boolean = false;
  step5: boolean = false;
  step6: boolean = false;

  dataStep1: any;
  dataStep2: any;
  capturedImage: any;

  backTrue: boolean;

  businesses: any[]

  captureState(data: { state: boolean; nin: boolean; name: string }) {
    this.type = data.nin;
    this.biodata = data.name;
    console.log(data);
    if (data.state == true && data.nin == false) {
      this.step1 = !this.step1;
      this.step2 = !this.step2;
    } else {
      this.step1 = !this.step1;
      this.step3 = !this.step3;
    }
  }

  captureVerifycode(data: { state: boolean }) {
    if (data.state == true) {
      this.step2 = !this.step2;
      this.step3 = !this.step3;
    }
  }
  captureSuccess(data: { state: boolean }) {
    if (data.state == true) {
      this.step3 = !this.step3;
      this.step4 = !this.step4;
    }
  }
  captureCamera(data: { state: boolean }) {
    // if (data.state == true && !this.type){
    this.step4 = !this.step4;
    this.step5 = !this.step5;
    // }else{
    //     this.step4 =!this.step4;
    //     this.step6 =!this.step6;
    // }
  }

  goToPreview(data: { submit: boolean; image: string }) {
    this.step5 = !this.step5;
    this.step6 = !this.step6;
    this.capturedImage = data.image;
    this.previewDetails = {
      dataStep1: this.dataStep1,
      dataStep2: this.dataStep2,
      capturedImage: data.image,
    };
  }

  moveFromTo(step: { step: number }) {
    switch (step.step) {
      case 1:
        this.step1 = true;
        this.step2 = false;
        this.step3 = false;
        this.step4 = false;
        this.step5 = false;
        this.step6 = false;
        this.backTrue = true;
        break;
    }
  }

  data1(data: any) {
    this.dataStep1 = data;
  }
  data2(data: any) {
    this.dataStep2 = data;
  }

  goBack(currentStep: number) {
    switch (currentStep) {
      case 2: // back to step1
        this.step2 = false;
        this.step1 = true;
        break;
      case 3: // back to step2
        this.step3 = false;
        this.step2 = true;
        break;
      case 4: // back to step3
        this.step4 = false;
        this.step3 = true;
        break;
      case 5: // back to step4
        this.step5 = false;
        this.step4 = true;
        break;
      case 6: // back to step5
        this.step6 = false;
        this.step5 = true;
        break;
    }
  }

  img: string;
  isSubmitting: boolean;
  async submit() {
    // const photo = this.uploadBase64File(data.image);
    let capturedImageUrl;
    capturedImageUrl = this.capturedImage
      ? await this.upoadFile(this.capturedImage)
      : null;
    const details = {
      hasNin: Boolean(this.dataStep1?.nin),
      nin: this.dataStep1?.nin,
      title: this.dataStep1?.title,
      firstName: this.dataStep1?.firstname,
      lastName: this.dataStep1?.lastname,
      middleName: this.dataStep1?.middlename,
      email: this.dataStep1?.email,
      phoneNumber: this.dataStep1?.phone,
      dateOfBirth: this.dataStep1?.dob,
      nationality: this.dataStep1?.nationality,
      gender: this.dataStep1?.gender,
      password: this.dataStep1?.password,
      photo: capturedImageUrl || this.dataStep1?.ninDetails?.photo,
      address: this.dataStep2?.address,
      // OTHER INFORMATION STEP
      maritalStatus: this.dataStep2?.isMarried ? "MARRIED" : "SINGLE", // ⚠️ not present in new form

      // new employment & income fields
      incomeCategory: this.dataStep2?.incomeCategory,
      employerName: this.dataStep2?.employerName,
      sourceOfIncome: this.dataStep2?.sourceOfIncome?.id,
      totalIncome: this.dataStep2?.totalAnnualIncome
        ? Number(this.dataStep2?.totalAnnualIncome)
        : null,
      natureOfBusiness: this.dataStep2?.natureOfBusiness,
      salaryRange: this.dataStep2?.incomeRange,

      // housing info
      accommodationType: this.dataStep2?.accommodationType,
      buildingType: this.dataStep2?.buildingType,
      rentPeriodCovered: this.dataStep2?.rentPeriodCovered,
      periodType: this.dataStep2?.periodType,
      propertyManagement: this.dataStep2?.propertyManagement,
      rentAmount: this.dataStep2?.annualRentAmount
        ? Number(this.dataStep2?.annualRentAmount)
        : null,

      // landlord info
      landLordName: this.dataStep2?.landlordFullName,
      landLordPhoneNumber: this.dataStep2?.landlordPhoneNumber,
      landLordEmail: this.dataStep2?.landlordEmail,
      landLordAddress: this.dataStep2?.landlordAddress,
      landLordAsin: this.dataStep2?.landlordAsin,
      landMark: this.dataStep2?.landMark,
      sharedApartmentWithLandLord:
        this.dataStep2?.doesLandlordLiveSameApartment === "true",

      // vehicles
      hasVehicle: this.dataStep2?.hasVehicle,
      numberOfVehicles: this.dataStep2?.numberOfVehicles ? Number(this.dataStep2?.numberOfVehicles) : 0,
      hasProperty: this.dataStep2?.hasProperty,
      propertyType: this.dataStep2?.propertyType,

      // location
      state: this.dataStep2?.state?.id,
      stateOfOrigin: this.dataStep2?.stateOfOrigin?.id,
      stateOfOriginLga: this.dataStep2?.stateOfOrigin?.id,
      lga: this.dataStep2?.lga?.id,

      // tax & assets
      closestTaxOffice: this.dataStep2?.closestTaxOffice,
      lastYearPurchase: this.dataStep2?.hasPurchasedAsset === "true",
      purchaseItem: this.dataStep2?.assetItems,
      lifestyleAsset: this.dataStep2?.lifestyleAsset,

      // asin mapping
      ownerAsin: this.dataStep2?.asin, // ⚠️ check with backend if this belongs to owner or landlord

      // salary mapping
      annualSalary: this.dataStep2?.totalAnnualIncome ? Number(this.dataStep2?.totalAnnualIncome) : null,

      // vehicle duplication (if backend expects both)
      vehicleCount: this.dataStep2?.numberOfVehicles ? Number(this.dataStep2?.numberOfVehicles) : 0,
      hasBusiness: this.dataStep2?.hasBusiness,
      businessASIN: this.dataStep2?.businessASIN,
      businessName: this.dataStep2?.businessName,
      businessDetailsDtos: this.dataStep2?.businesses,
    };

    const url = "/auth/enumeration/individual/save";
    this.isSubmitting = true;
    this.apiServer.loginPost_(url, details).subscribe(
      (res) => {
        console.log(res);
        this.isSubmitting = false;

        if (res.data.message.includes("successfully")) {
          this.router.navigate([`/create-asin/success/${res.data.asin}`], {
            queryParams: { message: res.data.message },
          });
        } else {
          alertify.set("notifier", "position", "top-right");
          alertify.error("Error Occurred, Please try again later.");
        }
      },
      (error) => {
        this.isSubmitting = false;

        alertify.set("notifier", "position", "top-right");
        alertify.error("Error Occurred, Please try again later.");
      }
    );
  }

  uploadBase64File(base64String: string): any {
    // Step 1: Decode Base64 to binary data
    const url = "/auth/enumeration/upload/photo/individual";
    const binaryString = atob(base64String.split(",")[1]);
    const binaryLen = binaryString.length;
    const bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    const fileBlob = new Blob([bytes], { type: "application/json" });

    // Step 3: Create FormData object and append the Blob as a file
    const formData = new FormData();
    formData.append("file", fileBlob);

    this.apiServer.loginPost2_(url, formData).subscribe((res) => {
      return res.data;
    });
  }

  async upoadFile(file: string): Promise<string | null> {
    let url = "/auth/enumeration/upload/photo/individual/base64";
    try {
      const res = await firstValueFrom(
        this.apiServer.loginPost_(url, JSON.stringify(file))
      );
      return res?.message || null;
    } catch (err) {
      console.error("Upload failed", err);
      return null;
    }
  }
}
